var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-spm": "report", "data-spm-stop": "init" } },
    [
      _c(
        "a",
        {
          staticClass: "report-c",
          attrs: { href: _vm.feedbackUrl, target: "_blank" },
        },
        [
          _c("img", {
            staticClass: "img-default",
            attrs: {
              src: "//statics.itc.cn/msfe/pictures/icon_report_empty_4@2x.png",
            },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "img-hover",
            attrs: { src: require("../images/icon_report_empty_default.png") },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "report",
              staticStyle: { "text-decoration": "underline" },
            },
            [_vm._v("内容举报")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }